import { ceil, each, findIndex, floor, isObject, pullAt } from 'lodash';
export function toFixed(num, fractionDigits = 2) {
    return floor(ceil(num, fractionDigits * 2), fractionDigits);
}
/**
 * 差集
 * @param firstArr
 * @param secondArr
 */
export function differenceSet(firstArr, secondArr) {
    for (const sv of secondArr) {
        const index = findIndex(firstArr, (fv) => fv === sv);
        if (index > -1) {
            pullAt(firstArr, index);
        }
    }
    return firstArr;
}
export function findActivityProduct(productMap, product) {
    if (!productMap) {
        return;
    }
    if (!product || product.productAndModifierPrice <= 0) {
        return;
    }
    const findProduct = productMap[product.categoryNo] || // 全部分类
        productMap[[product.productNo, product.scaleNo].join('_')] || // 精确到规格
        productMap[product.productNo]; // 全部餐品
    return findProduct;
}
/**
 * 转餐品map数据
 * @param products
 * @returns
 */
export function prodctToMap(products) {
    const productMap = {};
    each(products, (product) => {
        let key = '';
        if (product.categoryNo && !product.productNo && !product.scaleNo) {
            key = product.categoryNo;
        }
        else if (product.productNo && !product.scaleNo) {
            key = product.productNo;
        }
        else if (product.productNo && product.scaleNo) {
            key = [product.productNo, product.scaleNo].join('_');
        }
        productMap[key] = product;
    });
    return productMap;
}
/**
 * @param name 错误名称
 * @param upload 是否删除
 * @param message
 * @returns
 */
export function traceLog({ name = 'CustomErrorLog', upload = true, message, }) {
    var _a;
    if (!upload) {
        return console.error(name, message);
    }
    try {
        (_a = window === null || window === void 0 ? void 0 : window.__bl) === null || _a === void 0 ? void 0 : _a.error({
            name,
            message: message && isObject(message) ? JSON.stringify(message) : message,
        });
    }
    catch (e) { }
}
//# sourceMappingURL=utils.js.map